// Define action types for family preset values
export const SET_APPOINTMENT_ID = 'SET_APPOINTMENT_ID';
export const SET_DATE = 'SET_DATE';
export const SET_TIME = 'SET_TIME';
export const SET_SESSIONS_PER_WEEK = 'SET_SESSIONS_PER_WEEK';
export const SET_SESSION_TYPE = 'SET_SESSION_TYPE';
export const SET_REPEAT = 'SET_REPEAT';    
export const SET_SUBJECT_ID = 'SET_SUBJECT_ID';
export const SET_APPOINTMENT_TYPE = 'SET_APPOINTMENT_TYPE';
export const RESET_FAMILY_PRESET_VALUES = 'RESET_FAMILY_PRESET_VALUES';
export const SET_DURATION = 'SET_DURATION';




